export function deadline<T>(
  deadlineMs: number,
  fn: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
  const ac = new AbortController();
  const promise = fn(ac.signal);
  const timeout = setTimeout(() => ac.abort(), deadlineMs);

  return promise.finally(() => clearTimeout(timeout));
}
